import { render, staticRenderFns } from "./DataProfile.vue?vue&type=template&id=46e8b96c&scoped=true&"
import script from "./DataProfile.vue?vue&type=script&lang=js&"
export * from "./DataProfile.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./DataProfile.vue?vue&type=style&index=1&lang=css&"
import style2 from "./DataProfile.vue?vue&type=style&index=2&id=46e8b96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8b96c",
  null
  
)

export default component.exports